import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { get_beneficiary_by_id, delete_beneficiary } from '../api/beneficiary_api';
import { delete_transactions_by_beneficiary_id } from '../api/transaction_api';
import { delete_documents_by_beneficiary_id } from '../api/document_api';
import Transactions from './Transactions';
import Documents from './Documents';
import '../styles/BeneficiaryDetails.css';
import { uploadDocument } from './AddDocument';
import GenericDetails from './GenericDetails';


const BeneficiaryDetails = () => {
    

    const [beneficiary, setBeneficiary] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { beneficiary_id } = useParams();
    const [docRefreshFlag, setDocRefreshFlag] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await get_beneficiary_by_id(beneficiary_id);
                setBeneficiary(data);
            } catch (err) {
                setError('טעינת פרטים נכשלה');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [beneficiary_id]);

    const handleAddTransactionClick = () => {
        navigate(`/beneficiaries/${beneficiary_id}/add_transaction`, {
            state: { beneficiaryName: `${beneficiary.first_name} ${beneficiary.last_name}` }
        });
    };

    const handleDeleteClick = async () => {
        const confirmDelete = window.confirm('האם אתה בטוח שברצונך למחוק את הנתמך? פעולה זו אינה הפיכה.');
        if (confirmDelete) {
            try {
                await delete_beneficiary(beneficiary_id);
                await delete_transactions_by_beneficiary_id(beneficiary_id);
                await delete_documents_by_beneficiary_id(beneficiary_id);
                alert('נמחק בהצלחה');
                navigate('/beneficiaries');
            } catch (err) {
                console.error(err);
                alert('אירעה שגיאה בעת ניסיון המחיקה');
            }
        }
    };

    const handleUpdateClick = () => {
        navigate(`/beneficiaries/${beneficiary_id}/update_beneficiary`);
    };
    

 
    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        try {
            await uploadDocument(beneficiary_id, file);
            alert('המסמך הועלה בהצלחה');
            setDocRefreshFlag(prev => !prev);
        } catch (err) {
            console.error(err);
            alert('אירעה שגיאה בהעלאת המסמך');
        }
    };

    if (loading) return <div>טוען...</div>;
    if (error) return <div>{error}</div>;

    return (
        <>
           <div className="top-buttons-container">
                {/* כפתור חזרה דף אחורה - עם חץ */}
                <button className="round-nav-btn" onClick={() => navigate(-1)} title="חזרה">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                </button>
                {/* כפתור דף הבית - עם בית */}
                <button className="round-nav-btn" onClick={() => navigate('/main_screen')} title="דף הבית">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2">
                        <path d="M12 3L2 12h3v7h4v-5h6v5h4v-7h3L12 3z" />
                    </svg>
                </button>
            </div>
    
            <div className="beneficiary-details-container">
                {/* כאן מוצגים הנתונים בלבד */}
                <GenericDetails 
                    data={beneficiary} 
                    type="beneficiary"
                    onDelete={null} 
                    onUpdate={null} 
                />
    
             
                <div className="buttons-container" style={{ display: 'flex', flexDirection: 'row-reverse', gap: '10px', marginTop: '20px', flexWrap: 'wrap' }}>
                    
             
                    <button className="action-btn delete-btn" onClick={handleDeleteClick}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M3 5.5H17" />
                        <path d="M7 5.5V4C7 3.44772 7.44772 3 8 3H12C12.5523 3 13 3.44772 13 4V5.5" />
                        <path d="M9 8.5V15.5" />
                        <path d="M11 8.5V15.5" />
                        <path d="M5 5.5H15L16 17C16 17.5523 15.5523 18 15 18H5C4.44772 18 4 17.5523 4 17L5 5.5Z" />
                    </svg> מחיקת כרטסת
                    </button>
    
                    <button className="action-btn update-btn" onClick={handleUpdateClick}>
                        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"><path d="M12 20h9" strokeWidth="2" /><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" strokeWidth="2" /></svg>
                        עדכון פרטים
                    </button>
    
                    {/* כפתורי הפעולה והמסמכים */}
                    <button className="action-btn add-transaction-btn" onClick={handleAddTransactionClick}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2">
                            <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="16" /><line x1="8" y1="12" x2="16" y2="12" />
                        </svg>
                        הוספת פעולה
                    </button>
    
                    <label htmlFor="file-upload" className="action-btn upload-label" style={{ cursor: 'pointer', margin: 0 }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2">
                            <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="16" /><line x1="8" y1="12" x2="16" y2="12" />
                        </svg>
                        העלאת מסמך
                    </label>
                    <input id="file-upload" type="file" onChange={handleFileUpload} style={{ display: 'none' }} />
                </div>
    
                <Transactions beneficiary={beneficiary} />
                <Documents beneficiary_id={beneficiary_id} refreshTrigger={docRefreshFlag} />
            </div>
        </>
    );
};

export default BeneficiaryDetails;


